<mat-horizontal-stepper [linear]="true" #acessoClienteStepper>
  <mat-step [stepControl]="acessoFormGroup">
    <form (keydown)="checkSubmit($event)">
      <h3>{{subtitulo}}</h3>
      <div class="row">
        <div class="col-xl-12">
          <app-campo
            [formulario]="acessoFormGroup"
            descricao="{{'email' | transloco}}"
            autoPreenchimento="off"
            nomeControle="email"
            classe="horizontal-100"
          ></app-campo>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <app-campo
            [formulario]="acessoFormGroup"
            descricao="{{'senha' | transloco}}"
            tipo="password"
            autoPreenchimento="off"
            nomeControle="senha"
            classe="horizontal-100"
          ></app-campo>
          <p><a role="button" routerLink="" (click)="recuperarSenha()">{{'esqueci_senha' | transloco}}</a></p>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-6 order-xl-last">
          <app-botao
            texto="{{'acessar' | transloco}}"
            textoExecutando="{{'acessando' | transloco}}"
            [executando]="loading"
            classe="btn-primary horizontal-100"
            posicaoDoIcone="direita"
            (clique)="verificarUsuario()"
          >
          </app-botao>
        </div>
        <div class="col-xl-6">
          <app-botao
            texto="{{'nao_tenho_conta' | transloco}}"
            [desabilitado]="loading"
            classe="text-uppercase horizontal-100 btn-primary"
            tamanhoDoTexto="0.65rem"
            (clique)="aindaNaoTenhoRegistro()"
          >
          </app-botao>
        </div>
      </div>
    </form>
  </mat-step> 
</mat-horizontal-stepper>
<div id="recaptcha-container"></div>